import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinImageClick,
  GTMEventGlycerinButtonClick,
} from '@packages/tracking/src/types/events';

export const useInstallmentCalculatorTracking = () => {
  const dispatchTracking = useTracking();

  const trackGlycerinImageClick = () => {
    dispatchTracking<GTMEventGlycerinImageClick>({
      event: 'ImageClick',
      ImageClickData: {
        category: 'Ratenrechner',
        detail: 'Infosymbol',
        label: 'Kredit-Promo',
      },
    });
  };

  const trackGlycerinButtonClick = ({
    detail,
  }: Pick<GTMEventGlycerinButtonClick['ButtonClickData'], 'detail'>) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: 'Ratenrechner',
        detail: `Monatsrate ${detail}`,
        label: 'Kredit-Promo',
      },
    });
  };

  return { trackGlycerinImageClick, trackGlycerinButtonClick };
};
